export default "/images/64a8707a34abf51eba0e07b868d0e531.avif";